// CSS for this component is provided by public/index.css.
// This markup should be identical to the preloader in public/index.html
const PageLoader = () => {
  return (
    <div className="preloader-container" data-testid="page-loader">
      <div className="preloader">
        <div />
        <div />
        <div />
        <div />

        <img
          src="/favicon.svg"
          width="75"
          height="75"
          alt="Carro"
          style={{ borderRadius: '12px' }}
        />
      </div>
    </div>
  );
};

export default PageLoader;
